import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * MENTOR — Zweig 👀 "Nur umschauen" (read-only · §9.3).
 *
 * Gestartet aus W1 (MentorEntry). Erklaert die Ansicht ohne etwas anzulegen und
 * endet VOR dem Freigeben; bietet am Ende den Wechsel ins echte Loslegen
 * (startTour MentorSingleShift).
 *
 * AP-6 / 6a: lauffaehiges Geruest (Orientierung + CTA "richtig loslegen"). Mehr
 * read-only-Stationen folgen in 6d.
 */
export const MENTOR_EXPLORE_TOUR: TourConfig = {
  id: TourFeature.MentorExplore,
  version: 1,
  title: 'TUTORIAL.MENTOR.EXPLORE.TITLE',
  description: 'TUTORIAL.MENTOR.EXPLORE.DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  triggerContext: { route: '/planner' },
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: true,
    cooldownHoursAfterDismiss: 72,
    cooldownHoursAfterSnooze: 24,
    suppressAfterCompletion: false,
  },
  priority: 220,
  estimatedDurationSec: 120,
  // feature-discovery = gefuehrter Flow (runTourV2), NICHT help-mode. Nicht im
  // Setup-Counter (zaehlt nur category==='setup').
  category: 'feature-discovery',
  launchContext: { route: '/planner' },
  chapters: [
    {
      id: 'explore',
      title: 'TUTORIAL.MENTOR.EXPLORE.TITLE',
      steps: [
        {
          // C.1 — read-only Rundblick.
          id: 'c1-overview',
          anchor: AnchorId.PlannerView,
          title: 'TUTORIAL.MENTOR.EXPLORE.C1.TITLE',
          content: 'TUTORIAL.MENTOR.EXPLORE.C1.CONTENT',
          placement: 'auto',
          showNextButton: true,
        },
        {
          // C.2 — Zwei Blicke (read-only).
          id: 'c2-view-switch',
          anchor: AnchorId.PlannerViewSwitch,
          title: 'TUTORIAL.MENTOR.EXPLORE.C2.TITLE',
          content: 'TUTORIAL.MENTOR.EXPLORE.C2.CONTENT',
          placement: 'bottom',
          showNextButton: true,
        },
        {
          // C.3 — Wochen im Blick (read-only).
          id: 'c3-week-overview',
          anchor: AnchorId.CalendarNavigation,
          title: 'TUTORIAL.MENTOR.EXPLORE.C3.TITLE',
          content: 'TUTORIAL.MENTOR.EXPLORE.C3.CONTENT',
          placement: 'bottom',
          showNextButton: true,
        },
        {
          // C.n — Abschluss: jetzt richtig loslegen?
          id: 'c-handoff',
          anchor: AnchorId.PlannerView,
          title: 'TUTORIAL.MENTOR.EXPLORE.HANDOFF.TITLE',
          content: 'TUTORIAL.MENTOR.EXPLORE.HANDOFF.CONTENT',
          placement: 'auto',
          showNextButton: true,
          actions: [
            {
              labelKey: 'TUTORIAL.MENTOR.EXPLORE.HANDOFF.CTA',
              icon: 'fa-solid fa-play',
              startTour: TourFeature.MentorSingleShift,
              variant: 'primary',
            },
          ],
        },
      ],
    },
  ],
};
